import { ServerPerformanceEvent } from './ILogger'

export const SSRPerformanceStore = (initialData: Array<ServerPerformanceEvent> = []) => {
	const eventData: Array<ServerPerformanceEvent> = initialData

	const addSSRPerformanceEvent = (name: string) => {
		eventData.push({ name: `(SERVER)- ${name}`, startTime: Date.now() })
	}
	const getAllSSRPerformanceEvents = () => eventData

	return { addSSRPerformanceEvent, getAllSSRPerformanceEvents }
}
